import { NonIdealState, NonIdealStateProps } from "@blueprintjs/core"
import React from "react"

export type NoResultsProps = NonIdealStateProps
const NoResults = ({ ...props }: NoResultsProps) => {
  return <NonIdealState {...props} />
}

export default NoResults
